import React, { Fragment, useEffect, useState } from "react";
import AuthService from "../../../../AuthService";
import Utils from "../../../../utils";
import "../../styles.css";
import Detalhes from "../compDetalhesPedido";

import { spawnNotification } from "../../../../utils/BrowserNotification";

import { Box, Button, Grid } from "@mui/material";
import { useSnackbar } from "notistack";
import FiltroPedidos from "./parts/FiltroPedidos";
import PedidosTable from "./parts/PedidosTable";
import { useConfirm } from "../../../../components/DialogConfirm";
import { usePrompt } from "../../../../components/PromptDialog";

const pesquisaEmBranco = {
  ativo: "null",
  status: "PENDENTE",
  dataPedido: null,
  dataInicial: null,
  dataFinal: null,
  nomeCliente: "",
  statusIntegracao: "null",
  statusImpressao: "null",
  situacao: "null",
  tipo: "null",
  agendado: "null",
};

const Pedidos = (props) => {
  const [pedidos, setPedidos] = useState([]);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [pesquisa, setPesquisa] = useState({ ...pesquisaEmBranco });
  const [buscaAvancadaOpen, setBuscaAvancadaOpen] = useState(false);
  const [buscando, setBuscando] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [openInfo, setOpenInfo] = useState(false);
  const [totalCountPedidos, setTotalCountPedidos] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const confirm = useConfirm();
  const prompt = usePrompt();
  const handlePrintOut = async (pedido) => {
    const confirmado = await confirm({
      message: "Deseja permitir reimpressão do pedido ?",
    });
    if (!confirmado) return;

    const service = new AuthService();
    const pedidosBody = [{ id: pedido.id }];

    try {
      const retorno = await service.post(
        `/pedido/liberarParaNovaImpressao`,
        pedidosBody
      );
      const pedidoRet = retorno[0];
      pedido.statusImpressao = pedidoRet.statusImpressao;
      setPedidos([...pedidos]);
      enqueueSnackbar("Pedido liberado para re-impressão", {
        variant: "success",
      });
    } catch (err) {
      console.error(err);
      enqueueSnackbar(`erro: ${err}`, { variant: "error" });
    }
  };

  const handleMarcarComoImpresso = async (pedido) => {
    const confirmado = await confirm({
      message: "Deseja realmente criar uma cópia deste produto?",
    });
    if (!confirmado) return;

    const service = new AuthService();
    const pedidosBody = [
      {
        id: pedido.id,
        itens: pedido.itens.map((elem) => ({ id: elem.id })),
      },
    ];

    try {
      const retorno = await service.post(
        `/pedido/marcarComoImpresso`,
        pedidosBody
      );
      const pedidoRet = retorno[0];
      pedido.statusImpressao = pedidoRet.statusImpressao;

      if (pedidoRet.statusImpressao === "PENDENTE") {
        enqueueSnackbar("falha ao imprimir itens.", { variant: "error" });
      }

      setPedidos([...pedidos]);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = async (pedido) => {
    const confirmado = await confirm({
      message: "Deseja cancelar o pedido?",
    });
    if (!confirmado) return;

    const motivo = await prompt({
      message: "Informe o motivo do cancelamento",
      title: "Cancelar pedido",
    });

    if (!motivo) return;

    const service = new AuthService();

    try {
      const retorno = await service.delete(
        `/pedido/cancelar/${pedido.id}/${motivo}`
      );
      const idx = pedidos.findIndex((p) => p.id === retorno.id);
      const novosPedidos = [...pedidos];

      if (idx < 0) {
        novosPedidos.push(retorno);
      } else {
        novosPedidos.splice(idx, 1, retorno);
      }

      setPedidos(novosPedidos);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    buscarPedidosUtilizandoPesquisa();
    const interval = setInterval(
      verificaSeExistemPedidosPendentesNaoImpressos,
      30 * 1000
    );
    return () => clearInterval(interval);
    //eslint-disable-next-line
  }, []);

  const verificaSeExistemPedidosPendentesNaoImpressos = () => {
    const service = new AuthService();
    service
      .get(
        `/pedido/count?statusImpressao=PENDENTE&situacao=PENDENTE&ativo=true`
      )
      .then((countResult) => {
        const count = countResult.count;

        if (count && count > 0) {
          const action = (key) => (
            <Fragment>
              <Button
                onClick={() => {
                  setPesquisa({ ...pesquisaEmBranco });
                  setPage(0);
                  buscarPedidosUtilizandoPesquisa();
                }}
              >
                Atualizar
              </Button>
            </Fragment>
          );

          enqueueSnackbar(`Existem pedidos pendentes (${count})`, {
            variant: "warning",
            preventDuplicate: true,
            action,
          });

          spawnNotification(
            "Existem pedidos pendentes",
            `Existe ${count} pedidos pendentes. Clique para ver`,
            process.env.PUBLIC_URL + "/images/logoQrpedir.png",
            (event) => {
              const notification = event.currentTarget;
              if (notification) notification.close();
              window.focus();
            }
          );
        }
      })
      .catch((err) => {
        enqueueSnackbar("Falha ao verificar se existem pedidos pendentes", {
          variant: "error",
        });
        console.error(err);
      });
  };

  const handleChange = (event) => {
    setPesquisa({ ...pesquisa, [event.target.name]: event.target.value });
  };

  const handleDateChange = (data, name) => {
    if (!data || data === "Invalid Date") return;
    setPesquisa({ ...pesquisa, [name]: data });
  };

  const buscarPedidosUtilizandoPesquisa = () => {
    handleSearch(pesquisa);
  };

  const handleClickBuscarPedido = () => {
    setPage(0);
    buscarPedidosUtilizandoPesquisa();
  };

  const handleSearch = (pesquisa) => {
    let pesquisaVar = { ...pesquisa };
    const esc = encodeURIComponent;

    if (pesquisaVar.dataPedido instanceof Date) {
      pesquisaVar.dataPedido = `${pesquisaVar.dataPedido.getFullYear()}-${
        pesquisaVar.dataPedido.getMonth() + 1
      }-${pesquisaVar.dataPedido.getDate()}`;
    }

    if (pesquisaVar.dataInicial && pesquisaVar.dataFinal) {
      if (!(pesquisaVar.dataInicial instanceof Date))
        pesquisaVar.dataInicial = new Date(pesquisaVar.dataInicial);
      if (!(pesquisaVar.dataFinal instanceof Date))
        pesquisaVar.dataFinal = new Date(pesquisaVar.dataFinal);

      pesquisaVar.dataInicial = `${pesquisaVar.dataInicial.getFullYear()}-${
        pesquisaVar.dataInicial.getMonth() + 1
      }-${pesquisaVar.dataInicial.getDate()}`;
      pesquisaVar.dataFinal = `${pesquisaVar.dataFinal.getFullYear()}-${
        pesquisaVar.dataFinal.getMonth() + 1
      }-${pesquisaVar.dataFinal.getDate()}`;
    }

    const query = Object.keys(pesquisaVar)
      .map((k) =>
        pesquisaVar[k] != null &&
        pesquisaVar[k] !== "" &&
        pesquisaVar[k] !== "null"
          ? `${esc(k)}=${esc(pesquisaVar[k])}`
          : null
      )
      .filter(Boolean)
      .join("&");

    setBuscando(true);
    const service = new AuthService();
    service
      .request(
        `/pedido/find?${query}&first=${rowsPerPage * page}&max=${rowsPerPage}`
      )
      .then((response) => {
        const totalCount = response.headers.get("totalCount");
        setTotalCountPedidos(parseInt(totalCount));
        response.json().then((retorno) => {
          setPedidos(retorno);
          setBuscando(false);
        });
      })
      .catch((err) => {
        console.error(err);
        setBuscando(false);
      });
  };

  const handleChangeBuscaAvancadaOpen = () => {
    setBuscaAvancadaOpen(!buscaAvancadaOpen);
  };

  const handleOpenInfo = () => {
    setOpenInfo(!openInfo);
  };

  return (
    <div>
      <Box p={2}>
        <Grid container spacing={2}>
          <FiltroPedidos
            pesquisa={pesquisa}
            buscando={buscando}
            buscaAvancadaOpen={buscaAvancadaOpen}
            handleChange={handleChange}
            handleDateChange={handleDateChange}
            handleChangeBuscaAvancadaOpen={handleChangeBuscaAvancadaOpen}
            handleClickBuscarPedido={handleClickBuscarPedido}
          />
          <PedidosTable
            pedidos={pedidos}
            buscando={buscando}
            rowsPerPage={rowsPerPage}
            page={page}
            totalCountPedidos={totalCountPedidos}
            handleCancel={handleCancel}
            setPage={setPage}
            buscarPedidosUtilizandoPesquisa={buscarPedidosUtilizandoPesquisa}
            handlePrintOut={handlePrintOut}
            setPedidos={setPedidos}
            handleMarcarComoImpresso={handleMarcarComoImpresso}
            handleOpenInfo={handleOpenInfo}
            setPedidoSelecionado={setPedidoSelecionado}
            setRowsPerPage={setRowsPerPage}
            enqueueSnackbar={enqueueSnackbar}
            Utils={Utils}
          />
        </Grid>
      </Box>

      {!!openInfo && (
        <Detalhes
          pedido={pedidoSelecionado}
          open={openInfo}
          handleOpenInfo={handleOpenInfo}
        />
      )}
    </div>
  );
};

export default Pedidos;
